import apartmentTypes, { APARTMENT_TYPE, UnknownType } from "@elsa-zku/lib/constants/apartmentTypes";
import { Apartment } from "src/api/data-contracts";

export const disableNotificationsApartmentTypes = apartmentTypes({
  extend: {
    [APARTMENT_TYPE.FLAT]:         {
      short:  'Кв.',
      plural: 'Квартиры',
      icon:   require('../icons/flat.svg'),
    },
    [APARTMENT_TYPE.APARTMENT]:    {
      short:  'Апарт.',
      plural: 'Апартаменты',
      icon:   require('../icons/apartment.svg')
    },
    [APARTMENT_TYPE.COMMERCIAL]:   {
      short:  'Ком. п.',
      plural: 'Коммерческие помещения',
      icon:   require('../icons/commercial.svg')
    },
    [APARTMENT_TYPE.PARKING]:      {
      short:  'М/м.',
      plural: 'Паркинг',
      icon:   require('../icons/parking.svg')
    },
    [APARTMENT_TYPE.STORAGE]:      {
      short:  'Клад.',
      plural: 'Кладовки',
      icon:   require('../icons/storage.svg')
    },
    [APARTMENT_TYPE.CONSTRUCTION]: {
      short:  'Стр.',
      plural: 'Строения',
      icon:   require('../icons/construction.svg')
    },
  }
})
